import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-level-instruction',
  templateUrl: './level-instruction.component.html',
  styleUrls: ['./level-instruction.component.scss']
})
export class LevelInstructionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
